<div class="content-wrapper">
  <!-- Content Header (Page header) -->
  <section class="content-header">
    <h1>
      {{title}}
      <small>Control panel</small>
    </h1>
    <ol class="breadcrumb">
      <li>
        <a routerLink="">
          <i class="fa fa-dashboard"></i> Home
        </a>
      </li>
      <li class="active">{{title}}</li>
    </ol>
  </section>
  <!-- Main content -->
  <section class="content">
    <div class="row">
      <div class="col-xs-12">
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">{{title}} Table</h3>
            <!-- <button class="btn btn-success" (click)="initModal('create')">Create</button> -->
          </div>
          <!-- /.box-header -->
          <div class="box-body table-responsive no-padding">
            <table class="table table-hover table-striped">
              <thead>
                <tr>
                  <th>device ID</th>
                  <th>BOARD ID</th>
                  <th>BOARD NAME</th>
                  <th>ALARM SOUND</th>
                  <th>MAIN DEVICE</th>
                  <th>ACCEPT SUB</th>
                  <th class="w-1">UPDATE AT</th>
                  <th class="w-1">ACT.</th>
                </tr>
              </thead>
              <tbody *ngIf="!isLoading">
                <tr *ngFor="let deviceBoard of deviceBoardList">
                  <td>
                    {{ deviceBoard.device.deviceId }}
                  </td>
                  <td>
                    <span>{{ deviceBoard.board.id }}</span>
                  </td>
                  <td>
                    <span>{{ deviceBoard.boardName }}</span>
                  </td>
                  <td>
                    <span>{{ deviceBoard.alarmSound }}</span>
                  </td>
                  <td>
                    <span *ngIf="deviceBoard.mainDeviceId">ID: {{ deviceBoard.mainDeviceId }} - </span>{{ deviceBoard.mainDevice }}
                  </td>
                  <td>
                    <span>{{ deviceBoard.acceptSub }}</span>
                  </td>
                  <td>
                    <i class="fa fa-clock-o"></i>
                    {{ deviceBoard.updatedAt | date:'hh:mm dd-MM-yyyy' }}
                  </td>
                  <td>
                    <a class="btn btn-default" (click)="editdeviceBoard(deviceBoard)">
                      <i class="fa fa-edit" aria-hidden="true"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr *ngIf="deviceBoardList?.length === 0">
                  <td class="text-center" colspan="8">
                    <span>Can not found.</span>
                  </td>
                </tr>
                <tr *ngIf="deviceBoardList?.length !== 0">
                  <td colspan="8">
                    Displaying {{filterParams.page * filterParams.size + 1}} - {{ (filterParams.page) * filterParams.size + deviceBoardList?.length
                    }} of {{ totalElements }}
                    <ul *ngIf="filterParams.size < totalElements" class="pagination pull-right">
                      <li [class.disabled]="filterParams.page == 0" (click)="filterParams.page = filterParams.page - 1">
                        <a>
                          <span aria-hidden="true">«</span>
                          Previous</a>
                      </li>
                      <li [class.hidden]="filterParams.page < 3" (click)="filterParams.page = 0">
                        <a>1</a>
                      </li>
                      <li [class.hidden]="filterParams.page < 4" class="disabled hidden">
                        <a>...</a>
                      </li>
                      <li *ngFor="let number of initPaginate()" [class]="filterParams.page == number ? 'active' : class" [class.hidden]="(filterParams.page + 2 < number || filterParams.page - 2 > number)"
                        (click)="filterParams.page = number">
                        <a>{{ number + 1 }}</a>
                      </li>
                      <li [class.hidden]="filterParams.page > totalPage - 5" class="disabled">
                        <a>...</a>
                      </li>
                      <li [class.hidden]="filterParams.page >  totalPage - 4" (click)="filterParams.page = totalPage -1">
                        <a>{{ totalPage }}</a>
                      </li>
                      <li [class.disabled]="filterParams.page == totalPage - 1" (click)="filterParams.page = filterParams.page + 1">
                        <a>
                          <span aria-hidden="true">»</span>
                          Next</a>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tfoot>
            </table>


            <p class="text-center" *ngIf="isLoading">
              <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
              <span class="sr-only">Loading...</span>
            </p>
          </div>
          <!-- /.box-body -->
        </div>
        <!-- /.box -->
      </div>
    </div>

  </section>
</div>

<!-- Modal -->
<div id="myModal" class="modal fade" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <!-- Modal content-->
    <div class="modal-content" *ngIf="deviceBoardInfo">
      <form (ngSubmit)="onSubmit(formDeviceBoard)" #formDeviceBoard="ngForm">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">Edit device board info</h4>
        </div>
        <div class="modal-body">
            <input type="text" class="form-control hidden" name="id" ngModel [(ngModel)]="deviceBoardInfo.id" required /> 
          <div class="form-group">
            <label>Board name:</label>
            <input type="text" class="form-control" name="boardName" ngModel #txtBoardName="ngModel" [(ngModel)]="deviceBoardInfo.boardName"
              required>
            <span *ngIf="txtBoardName.errors?.required  && txtBoardName.dirty" class="text text-danger">Board name is required.</span>
          </div>
          <div class="form-group">
            <label>Alarm Sound:</label>
            <input type="text" class="form-control" name="alarmSound" ngModel #txtAlarmSound="ngModel" [(ngModel)]="deviceBoardInfo.alarmSound"
              required>
            <span *ngIf="txtAlarmSound.errors?.required  && txtAlarmSound.dirty" class="text text-danger">Alarm sound is required.</span>
          </div>
          <div class="form-group">
            <label>Accept sub:</label>
            <div class="radio">
              <label>
                  <input type="radio" [value]="true" name="acceptSub" ngModel [(ngModel)]="deviceBoardInfo.acceptSub">True</label>
              <label>
                  <input type="radio" [value]="false" name="acceptSub" ngModel [(ngModel)]="deviceBoardInfo.acceptSub">False</label>
            </div>
          </div>
          <div class="form-group">
              <label>Password:</label>
              <input type="password" class="form-control" name="password" ngModel [(ngModel)]="deviceBoardInfo.password">
            </div>
            <div class="form-group">
                <label>Password Accept:</label>
                <input type="password" class="form-control" name="passwordAccept" ngModel [(ngModel)]="deviceBoardInfo.passwordAccept">
              </div>
        </div>
        <div class="modal-footer">
          <button type="submit" [disabled]="formDeviceBoard.invalid" class="btn btn-primary">Save</button>
          <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
        </div>
      </form>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// /build/client-cms/src/app/device-board/device-board.component.html